/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_Q3Inputs */

const en_cad_faq_q3 = /** @type {(inputs: Cad_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can CADCraft open DWG files?`)
};

/**
* | output |
* | --- |
* | "Can CADCraft open DWG files?" |
*
* @param {Cad_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_q3 = /** @type {((inputs?: Cad_Faq_Q3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_Q3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_q3(inputs)
});
export { cad_faq_q3 as "cad.faq.q3" }